export enum TABS {
  areas = 'areas',
  courses = 'courses',
  participants = 'participants',
}

export const prefix = 'monitoring'

export enum Columns {
  name = 'user_full_name',
  userLmsActive = 'user_active_filter',
  area = 'user_area_name',
  advance = 'advance',
  lessons = 'lessons',
  progress = 'enrol_overall_progress',
  requiredProfiles = 'course_required_profiles_id_and_user_lms_profiles_id',
  optionalProfiles = 'course_optional_profiles_id_and_user_lms_profiles_id',
  stateEvaluations = 'state_evaluations',
  finalState = 'enrol_synchronous_course_enrol_final_state',
  integrationStatus = 'enrol_integration_status',
}
